import { options } from '@shared/shared.module';
import { Formio } from 'angular-formio';
import { interval } from 'rxjs';

const selectboxesBase = (Formio as any).Components.components.selectboxes;
// console.log('selectboxesBase', selectboxesBase);
// console.log(selectboxesBase);
const Components = (Formio as any).Components;

export class CustomSelectBoxes extends selectboxesBase {

    /**
     * Get the value of the component from the dom elements.
     *
     * @returns {Array}
     */

    // getValue() {

    // }

    /**
     * Set the value of the component into the dom elements.
     * @param value
     * @returns {Array}
     */
    // setValue(value) {

    // }

}

export function registryCustomSelectBoxesFieldTypeComponent() {
    Components.addComponent('selectBoxes', CustomSelectBoxes);
}